export default __webpack_public_path__ + "static/media/avi-pink.7167c628.png";